import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { TitleOfferLightFragmentDoc } from '../../../buybox/graphql/fragments/Offer.fragment';
export type GetPlacementMutationVariables = Types.Exact<{
	input: Types.GetAdInput;
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	platform: Types.Platform;
	enableCreatives: Types.Scalars['Boolean']['input'];
}>;

export type GetPlacementMutation = {
	__typename?: 'Mutation';
	getPlacement: {
		__typename: 'GetAdPayload';
		bidID?: string | null;
		ads?: Array<
			| {
					__typename: 'CreativeFreeTrialContent';
					adContent: string;
					name: string;
					adID: number;
					campaignID: number;
			  }
			| {
					__typename: 'CreativeGenericContent';
					adContent: string;
					name: string;
					adID: number;
					campaignID: number;
			  }
			| { __typename: 'CreativeQTVContent'; adContent: string; name: string; adID: number; campaignID: number }
			| {
					__typename: 'CreativeSQTVContent';
					offerSource?: string | null;
					similarityScore: number;
					adContent: string;
					name: string;
					adID: number;
					campaignID: number;
					similarTitle: {
						__typename: 'AdSimilarTitle';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						content: {
							__typename: 'AdSimilarTitleContent';
							title: string;
							posterUrl?: string | null;
							backdrops: Array<{ __typename: 'Backdrop'; backdropUrl: string }>;
							scoring?: {
								__typename: 'Scoring';
								imdbVotes?: number | null;
								imdbScore?: number | null;
								tomatoMeter?: number | null;
								certifiedFresh?: boolean | null;
								jwRating?: number | null;
							} | null;
							interactions: { __typename: 'InteractionAttributes'; votesNumber: number };
							genres: Array<{ __typename: 'Genre'; translation: string }>;
							tags: Array<{ __typename: 'Tag'; technicalName: string; translatedName: string }>;
						};
						offers: Array<{
							__typename: 'Offer';
							id: string;
							monetizationType: Types.MonetizationType;
							presentationType: Types.PresentationType;
							standardWebURL?: string | null;
							package: {
								__typename: 'Package';
								id: string;
								packageId: number;
								clearName: string;
								shortName: string;
								icon: string;
								iconWide: string;
							};
						}>;
					};
			  }
			| { __typename: 'CreativeSRContent'; adContent: string; name: string; adID: number; campaignID: number }
			| { __typename: 'CreativeSwiperContent'; adContent: string; name: string; adID: number; campaignID: number }
		> | null;
	};
};

export const GetPlacementDocument = gql`
	mutation GetPlacement(
		$input: GetAdInput!
		$country: Country!
		$language: Language!
		$platform: Platform!
		$enableCreatives: Boolean!
	) {
		getPlacement(input: $input) {
			bidID
			ads {
				__typename
				adContent
				name
				adID
				campaignID
				... on CreativeSQTVContent @include(if: $enableCreatives) {
					offerSource
					similarityScore
					similarTitle {
						id
						objectId
						objectType
						content {
							title
							posterUrl
							backdrops(limit: 1) {
								backdropUrl
								__typename
							}
							scoring {
								imdbVotes
								imdbScore
								tomatoMeter
								certifiedFresh
								jwRating
								__typename
							}
							interactions {
								votesNumber
								__typename
							}
							genres {
								translation(language: $language)
								__typename
							}
							tags {
								technicalName
								translatedName
								__typename
							}
							__typename
						}
						offers(country: $country, platform: $platform) {
							...TitleOfferLight
							__typename
						}
						__typename
					}
					__typename
				}
			}
			__typename
		}
	}
	${TitleOfferLightFragmentDoc}
`;
